export const GET_BID_PRODUCT = 'GET_BID_PRODUCT'
export const GET_UP_NEXT_PRODUCT = 'GET_UP_NEXT_PRODUCT'
export const GET_BANNER_HOME = 'GET_BANNER_HOME'
export const GET_TOTAL_USER_BID = 'GET_TOTAL_USER_BID'
export const TYPE_INTRO_TOUR = "TYPE_INTRO_TOUR"
export const SET_SHWE_HOURS_ICON = "SET_SHWE_HOURS_ICON"
export const SET_ADVER_TISEMENT = "SET_ADVER_TISEMENT"
